import { render, staticRenderFns } from "./CeremonyAttendeeFields.vue?vue&type=template&id=08c86eef"
import script from "./CeremonyAttendeeFields.vue?vue&type=script&setup=true&lang=js"
export * from "./CeremonyAttendeeFields.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports